var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.2,270l-33.3-94.5L410.2,81H202.6c10.9-8.2,18-21.3,18-36c0-24.8-20.2-45-45-45c-24.8,0-45,20.2-45,45 c0,19.6,12.5,36.2,30,42.4v319.9h-32V482H101v30h298.7v-30H372v-74.7H190.7V270H410.2z M342,482H158.7v-44.7H342V482z M367.8,240 H190.7V111h177.1L345,175.5L367.8,240z M175.7,30c8.3,0,15,6.7,15,15s-6.7,15-15,15c-8.3,0-15-6.7-15-15S167.4,30,175.7,30z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458,80.8v262.8c0,24.1-19.7,43.8-43.8,43.8H151.4c-24.1,0-43.8-19.7-43.8-43.8V80.8 c0-24.1,19.7-43.8,43.8-43.8h262.8C438.3,37,458,56.7,458,80.8z M392.3,234.1v-43.8h-219v43.8H392.3z M392.3,146.5v-43.8h-219 v43.8H392.3z M304.7,321.7v-43.8H173.3v43.8H304.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.4,431.2V475H63.8C39.7,475,20,455.3,20,431.2V124.6h43.8v306.6H370.4z"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceIcon);
export default __webpack_public_path__ + "static/media/resource_icon.da9b46feee6fc41d9eefa48a4c13b0b5.svg";
export { ForwardRef as ReactComponent };